import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/profile`;

class ProfileServices {
  async getMyProfile() {
    try {
      const action = API_ROUTE + "/me";
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getMyProfile:", error);
      throw error;
    }
  }

  async updateProfile(payload) {
    try {
      const action = API_ROUTE + "/update";
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in updateProfile:", error);
      throw error;
    }
  }

  async changePassword(payload) {
    try {
      const action = API_ROUTE + "/change-password";
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in changePassword:", error);
      throw error;
    }
  }
}

export default ProfileServices;

